<template>
  <div class="bsd-section">
    <modal :medium="true" :open="showResendModal" @close="showResendModal = false">
      <template slot="header">
        <div class="z-title z-title--small">
          <z-icon
            :icon="['far', 'check-circle']"
            color="success"
            size="extra-large"
            class="success-icon"
          />

          Confirmação enviada com sucesso
        </div>
      </template>
      <template slot="body">
        Enviamos um email de confirmação para o email <strong>{{ email.email }}</strong>
      </template>
    </modal>

    <div class="row">
      <div class="col-sm-6">
        <alert-box ref="alertBox" class="spacer-bottom-m" />
      </div>

      <div class="col-md-3 col-sm-6">
        <button class="z-button z-button--secondary z-button--block" @click="resendConfirmationEmail">
          Reenviar confirmação
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from 'components/zilla/alert-box';
import Modal from 'components/modal';
import ContactService from 'services/ContactService';

export default {
  components: {
    AlertBox,
    Modal,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
    changeSolicitated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showResendModal: false,
    };
  },
  mounted() {
    this.$refs.alertBox.show('warning', this.defineWarningMessage(), null);
  },
  methods: {
    resendConfirmationEmail() {
      ContactService.resendEmailConfirmation(this.email.id).then(() => {
        this.showResendModal = true;
      }).catch(() => {
        this.$refs.alertBox.show(
          'danger', 'Erro inesperado',
          'Houve um problema ao reenviar o email de confirmação.',
        );
      });
    },
    defineWarningMessage() {
      if (this.changeSolicitated) {
        return 'Confirme seu novo email para realizarmos a troca';
      }
      return 'Confirme seu email para receber notificações';
    },
  },
};
</script>
